export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/session_musicians.48eb332.svg";